import { Box, Button, Typography } from "@mui/material";

import styles from "./styles";

interface Props {
  planName: string;
  blurb: string;
  price: string;
  payTwo: string;
  saved: string;
  featuresIntro?: string;
  features: string[];
  canSubscribe: boolean;
  ctaLabel: string;
  subNote: string;
  onSubscribe: () => void;
}

const PlanCard = ({
  planName,
  blurb,
  price,
  payTwo,
  saved,
  featuresIntro,
  features,
  canSubscribe,
  ctaLabel,
  subNote,
  onSubscribe,
}: Props) => {
  return (
    <Box sx={styles.card}>
      <Box sx={styles.topRow}>
        <Box sx={styles.blurb}>{blurb}</Box>
        <Box sx={styles.giftChip}>🎁 3rd month free</Box>
      </Box>

      <Typography sx={styles.planName}>{planName}</Typography>

      <Box sx={styles.priceRow}>
        <Typography component="span" sx={styles.price}>
          ${price}
        </Typography>
        <Typography component="span" sx={styles.pricePer}>
          /mo
        </Typography>
      </Box>

      <Box sx={styles.offerBox}>
        <Box component="span" sx={styles.offerEmoji}>
          🎁
        </Box>
        <Typography sx={styles.offerText}>
          Pay <strong>{payTwo} for 2 months</strong>, your{" "}
          <Box component="strong" sx={{ color: "#117A65" }}>
            3rd month is free
          </Box>{" "}
          — that&apos;s <strong>{saved} saved</strong>.
        </Typography>
      </Box>

      <Box sx={styles.features}>
        {featuresIntro && (
          <Typography sx={styles.featuresIntro}>{featuresIntro}</Typography>
        )}
        {features.map((feat) => (
          <Box key={feat} sx={styles.featureRow}>
            <Box component="span" sx={styles.check}>
              ✓
            </Box>
            <Typography sx={styles.featureText}>{feat}</Typography>
          </Box>
        ))}
      </Box>

      <Box sx={styles.spacer} />

      <Button
        disableElevation
        disabled={!canSubscribe}
        onClick={onSubscribe}
        sx={styles.cta(canSubscribe)}
      >
        {canSubscribe ? "Subscribe now" : ctaLabel}
      </Button>

      <Typography sx={styles.subNote}>{subNote}</Typography>
    </Box>
  );
};

export default PlanCard;
